import { nextTick } from 'vue'

/**
 * 表单验证 hooks
 * @param {Object} options - 配置项
 * @param {Boolean} options.scrollToError - 是否滚动到错误位置
 * @returns {Function} validate - 验证函数
 */
export function useFormValidation(options = { scrollToError: true }) {
  /**
   * 验证表单
   * @param {Array} tasks - 验证任务列表，格式为 [{ ref: refObject, name: 'componentName' }]
   * @returns {Promise} - 返回验证结果的 Promise
   */
  const validate = (tasks) => {
    return new Promise((resolve, reject) => {
      // 如果传入的是普通的 ref 数组，转换为任务列表格式
      const validateTasks =
        Array.isArray(tasks[0]) || !tasks[0]?.ref
          ? tasks.map((ref) => ({
            ref,
            name: ref?.value?.$options?.name || 'unknown',
          }))
          : tasks

      // 执行所有验证
      Promise.all(
        validateTasks.map((task) => {
          return task.ref.value
            .validate()
            .catch(() => ({ failed: true, name: task.name, ref: task.ref }))
        }),
      ).then((results) => {
        const failedTask = results.find((result) => result && result.failed)

        if (!failedTask) {
          resolve(true)
          return
        }

        if (options.scrollToError) {
          const element = failedTask.ref.value?.$el
          if (element) {
            nextTick(async () => {
              // 查找最近的可滚动容器
              const scrollContainer = element.closest('.el-drawer__body') || document.querySelector('.el-drawer__body')

              if (scrollContainer) {
                // 计算元素相对于滚动容器的位置
                const elementRect = element.getBoundingClientRect()
                const containerRect = scrollContainer.getBoundingClientRect()
                const relativeTop = elementRect.top - containerRect.top + scrollContainer.scrollTop

                console.log('scrollContainer', scrollContainer)
                console.log('element', element)
                // 先滚动到大致位置
                scrollContainer.scrollTo({
                  top: relativeTop - 100,
                  behavior: 'smooth',
                })

                // 等待滚动完成
                // eslint-disable-next-line no-shadow
                await new Promise((resolve) => setTimeout(resolve, 300))

                // 如果组件有自己的 shake 方法，调用它
                if (typeof failedTask.ref.value?.shake === 'function') {
                  failedTask.ref.value.shake()
                }
              }
            })
          }
        }

        reject()
      })
    })
  }

  return {
    validate,
  }
}
